import Button from "@/components/Button"
import { useForm } from "@inertiajs/react"
import ErrorMessage from "./ErrorMessage"

const DeleteAccountForm = () => {
  const {
    data,
    setData,
    delete: destroy,
    errors,
    processing,
  } = useForm({
    confirm: "",
  })

  const isConfirmed = data.confirm === "DELETE"

  const handleDelete = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!isConfirmed) return

    destroy("/settings", { preserveScroll: "errors" })
  }

  return (
    <form onSubmit={handleDelete}>
      <h2 className="text-lg font-semibold text-gray-900">Delete account</h2>

      <div className="mt-3 overflow-hidden rounded-2xl border border-gray-100 bg-white shadow">
        <div className="space-y-5 px-4 pt-5 pb-6 sm:px-6">
          <p className="text-sm text-gray-600">
            Deletion of your account will <b>irrevocably</b> delete all data
            associated with your account. Please type <b>DELETE</b> into the
            field below, and confirm you wish to delete your account.
          </p>

          <div>
            <label htmlFor="confirmation" className="sr-only">
              Confirmation
            </label>

            <input
              type="text"
              id="confirmation"
              placeholder="Type DELETE here"
              autoComplete="off"
              required
              className="focus:ring-chessdrop-600 block w-full rounded-xl border-0 p-3 text-gray-900 shadow-sm ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
              value={data.confirm}
              onChange={(e) => setData("confirm", e.target.value)}
            />

            <ErrorMessage className="mt-1.5" message={errors.confirm} />
          </div>
        </div>

        <div className="flex items-center justify-end gap-x-3 border-t border-gray-200 px-4 py-4 sm:px-6">
          <Button
            type="submit"
            style="destructive"
            loading={processing}
            disabled={!isConfirmed || processing}
          >
            Delete my account
          </Button>
        </div>
      </div>
    </form>
  )
}

export default DeleteAccountForm
